(() => {
  const TAU = Math.PI * 2;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  const breathe = (c, t) => {
    const w = TAU * c.speed * t;
    return {
      bx: Math.max(0, c.fx * (1 + c.churn * Math.sin(w))),
      by: Math.max(0, c.fy * (1 + c.churn * Math.cos(w * 1.3))),
      s: c.scale * (1 + c.pulse * 0.5 * Math.sin(w * 0.7)),
    };
  };

  const consumers = [];

  const MELT_FPS = 30;
  const frameInterval = 1000 / MELT_FPS;
  const anyLive = () => consumers.some((c) => c.live());
  let t0 = null,
    last = 0,
    raf = 0;
  function frame(ts) {
    if (t0 === null) t0 = ts;
    raf = !reduced.matches && anyLive() ? requestAnimationFrame(frame) : 0;
    if (ts - last < frameInterval) return;
    last = ts;
    const t = (ts - t0) / 1000;
    consumers.forEach((c) => {
      if (c.live()) c.draw(t);
    });
  }
  function sync() {
    if (reduced.matches) {
      consumers.forEach((c) => {
        if (c.live()) c.draw(0);
      });
      return;
    }
    if (!raf && anyLive()) {
      t0 = null;
      raf = requestAnimationFrame(frame);
    }
  }

  (() => {
    const el = document.querySelector(".jm-reveal-basebox");
    const noise = document.getElementById("jm-melt2-noise");
    const disp = document.getElementById("jm-melt2-disp");
    if (!el || !noise || !disp) return;
    const cfg = { fx: 0.011, fy: 0.017, scale: 11, speed: 0.22, churn: 0.2, pulse: 0.13 };
    const c = {
      visible: false,
      live: () => c.visible,
      draw: (t) => {
        const { bx, by, s } = breathe(cfg, t);
        noise.setAttribute("baseFrequency", `${bx.toFixed(4)} ${by.toFixed(4)}`);
        disp.setAttribute("scale", s.toFixed(2));
      },
    };
    consumers.push(c);
    new IntersectionObserver(
      ([e]) => {
        c.visible = e.isIntersecting;
        sync();
      },
      { rootMargin: "100px" },
    ).observe(el);
  })();

  (() => {
    const hero = document.querySelector(".jm-hero");
    const reveal = document.querySelector(".jm-reveal");
    if (!hero) return;

    const cfg = { fx: 0.013, fy: 0.039, scale: 19, speed: 0.13, churn: 0.22, pulse: 0 };
    const IMG = "https://cdn.shopify.com/s/files/1/0646/3471/6413/files/jm-background.jpg?v=1783537516";
    const MAX_DPR = 1.5;
    const OVERSCAN = 0.94;

    const VERT = `
      attribute vec2 aPos;
      varying vec2 vUv;
      void main(){ vUv = aPos * 0.5 + 0.5; gl_Position = vec4(aPos, 0.0, 1.0); }
    `;
    const FRAG = `
      precision highp float;
      uniform sampler2D uImage;
      uniform vec2 uCssSize;
      uniform vec2 uImgSize;
      uniform vec2 uBaseFreq;
      uniform float uScale;
      varying vec2 vUv;
      float hash(vec2 p){ return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123); }
      float vnoise(vec2 p){
        vec2 i = floor(p), f = fract(p);
        vec2 u = f * f * (3.0 - 2.0 * f);
        return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x),
                   mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);
      }
      float fbm(vec2 p){ return (0.5 * vnoise(p) + 0.25 * vnoise(p * 2.0)) / 0.75; }
      vec2 cover(vec2 uv){
        float rC = uCssSize.x / uCssSize.y;
        float rI = uImgSize.x / uImgSize.y;
        vec2 s = rC > rI ? vec2(1.0, rI / rC) : vec2(rC / rI, 1.0);
        return (uv - 0.5) * s * ${OVERSCAN.toFixed(2)} + 0.5;
      }
      void main(){
        vec2 px = vUv * uCssSize;
        float nR = fbm(px * uBaseFreq);
        float nG = fbm(px * uBaseFreq + vec2(37.2, 17.8));
        vec2 disp = uScale * (vec2(nR, nG) - 0.5);
        gl_FragColor = texture2D(uImage, cover(vUv + disp / uCssSize));
      }
    `;

    const canvas = document.createElement("canvas");
    canvas.className = "jm-melt-canvas";
    canvas.setAttribute("aria-hidden", "true");
    const gl = canvas.getContext("webgl", {
      alpha: false,
      antialias: false,
      depth: false,
      stencil: false,
      powerPreference: "low-power",
    });

    let glReady = false,
      uni = null,
      imgSize = null;

    const c = {
      visible: true,
      occluded: false,
      live: () => glReady && c.visible && !c.occluded,
      draw: (t) => {
        const { bx, by, s } = breathe(cfg, t);
        gl.uniform2f(uni.baseFreq, bx, by);
        gl.uniform1f(uni.scale, s);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      },
    };
    consumers.push(c);

    const buildGL = () => {
      const sh = (type, src) => {
        const s = gl.createShader(type);
        gl.shaderSource(s, src);
        gl.compileShader(s);
        if (!gl.getShaderParameter(s, gl.COMPILE_STATUS))
          throw new Error(gl.getShaderInfoLog(s) || "shader compile failed");
        return s;
      };
      const prog = gl.createProgram();
      gl.attachShader(prog, sh(gl.VERTEX_SHADER, VERT));
      gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FRAG));
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS))
        throw new Error(gl.getProgramInfoLog(prog) || "program link failed");
      gl.useProgram(prog);

      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array([-1, -1, 3, -1, -1, 3]),
        gl.STATIC_DRAW,
      );
      const aPos = gl.getAttribLocation(prog, "aPos");
      gl.enableVertexAttribArray(aPos);
      gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

      uni = {
        cssSize: gl.getUniformLocation(prog, "uCssSize"),
        imgSize: gl.getUniformLocation(prog, "uImgSize"),
        baseFreq: gl.getUniformLocation(prog, "uBaseFreq"),
        scale: gl.getUniformLocation(prog, "uScale"),
      };
      gl.uniform1i(gl.getUniformLocation(prog, "uImage"), 0);
    };

    const uploadTexture = (img) => {
      const tex = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    };

    const resize = () => {
      const r = hero.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, MAX_DPR);
      const w = Math.max(1, Math.round(r.width * dpr));
      const h = Math.max(1, Math.round(r.height * dpr));
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w;
        canvas.height = h;
        gl.viewport(0, 0, w, h);
      }
      gl.uniform2f(uni.cssSize, r.width, r.height);
    };

    new IntersectionObserver(
      ([e]) => {
        c.visible = e.isIntersecting;
        sync();
      },
      { rootMargin: "100px" },
    ).observe(hero);

    if (reveal)
      new IntersectionObserver(
        ([e]) => {
          c.occluded = e.isIntersecting;
          sync();
        },
        { rootMargin: "0px 0px -99% 0px" },
      ).observe(reveal);

    if (gl)
      try {
        buildGL();
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          imgSize = [img.naturalWidth, img.naturalHeight];
          uploadTexture(img);
          gl.uniform2f(uni.imgSize, imgSize[0], imgSize[1]);
          resize();
          glReady = true;
          c.draw(0);
          hero.insertBefore(canvas, hero.firstChild);
          sync();
        };
        img.src = IMG;

        new ResizeObserver(() => {
          if (!glReady) return;
          resize();
          if (!raf) c.draw(0);
        }).observe(hero);

        canvas.addEventListener("webglcontextlost", (e) => {
          e.preventDefault();
          glReady = false;
          canvas.hidden = true;
          if (raf) {
            cancelAnimationFrame(raf);
            raf = 0;
          }
        });
        canvas.addEventListener("webglcontextrestored", () => {
          buildGL();
          if (!imgSize) return;
          const img2 = new Image();
          img2.crossOrigin = "anonymous";
          img2.onload = () => {
            uploadTexture(img2);
            gl.uniform2f(uni.imgSize, imgSize[0], imgSize[1]);
            resize();
            glReady = true;
            canvas.hidden = false;
            sync();
          };
          img2.src = IMG;
        });
      } catch (err) {
        console.error("melt: WebGL init failed, using static bg fallback", err);
      }
  })();

  sync();
})();

// production version pins to store (UK) midnight instead of local time
(() => {
  const outs = document.querySelectorAll("[data-jm3-count]");
  if (!outs.length) return;
  const pad2 = (n) => String(n).padStart(2, "0");
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    hourCycle: "h23",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const tick = () => {
    const parts = fmt.formatToParts(new Date());
    const at = (type) => Number(parts.find((p) => p.type === type).value);
    const into = at("hour") * 3600 + at("minute") * 60 + at("second");
    const s = (86400 - into) % 86400;
    const txt = `${pad2(Math.floor(s / 3600))}:${pad2(Math.floor(s / 60) % 60)}:${pad2(s % 60)}`;
    outs.forEach((el) => {
      el.textContent = txt;
    });
  };
  tick();
  setInterval(tick, 1000);
})();

// stays a native overflow-x scroller (swipe / hover+shift+wheel work unaided) - this code
// only syncs the chrome (arrows/dots/edge fades) to scroll position
(() => {
  const init = (rail) => {
  // scoped to this rail's .jm-railset so multiple rails each drive only their own dots/arrows
  const set = rail.closest(".jm-railset") || document;
  const dotsBox = set.querySelector("[data-jm3-dots]");
  if (!dotsBox) return;
  const wrap = rail.parentElement;
  const section = rail.closest("section");
  const prev = set.querySelector("[data-jm3-prev]");
  const next = set.querySelector("[data-jm3-next]");
  const cards = Array.from(rail.children);
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  const behavior = () => (reduced.matches ? "auto" : "smooth");
  // scroll offset of card i, relative to the rail's scroll origin
  const cardLeft = (i) => cards[i].offsetLeft - cards[0].offsetLeft;

  // deduped scroll targets, not one per card - trailing cards already visible at the
  // end position on wide screens share a dot instead of getting their own
  const positions = () => {
    const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const pts = [];
    cards.forEach((_, i) => {
      const p = Math.min(cardLeft(i), max);
      if (pts.length === 0 || p - pts[pts.length - 1] > 8) pts.push(p);
    });
    return pts;
  };

  let dots = [];
  const buildDots = (pts) => {
    dotsBox.replaceChildren();
    dots = pts.map((left, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", `Go to slide ${i + 1} of ${pts.length}`);
      b.addEventListener("click", () =>
        rail.scrollTo({ left, behavior: behavior() }),
      );
      dotsBox.append(b);
      return b;
    });
  };

  const sync = () => {
    const pts = positions();
    if (pts.length !== dots.length) buildDots(pts);
    dotsBox.toggleAttribute("hidden", pts.length <= 1);
    const max = rail.scrollWidth - rail.clientWidth;
    const atStart = rail.scrollLeft <= 4;
    const atEnd = rail.scrollLeft >= max - 4;
    wrap.toggleAttribute("data-at-start", atStart);
    wrap.toggleAttribute("data-at-end", atEnd);
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
    // focused position = nearest scroll target to current scroll
    let idx = 0;
    pts.forEach((p, i) => {
      if (Math.abs(p - rail.scrollLeft) < Math.abs(pts[idx] - rail.scrollLeft))
        idx = i;
    });
    dots.forEach((d, i) => {
      if (i === idx) d.setAttribute("aria-current", "true");
      else d.removeAttribute("aria-current");
    });
  };

  const step = () => (cards.length > 1 ? cardLeft(1) : rail.clientWidth);
  if (prev)
    prev.addEventListener("click", () =>
      rail.scrollBy({ left: -step(), behavior: behavior() }),
    );
  if (next)
    next.addEventListener("click", () =>
      rail.scrollBy({ left: step(), behavior: behavior() }),
    );

  let raf = 0;
  rail.addEventListener(
    "scroll",
    () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    },
    { passive: true },
  );
  addEventListener("resize", sync);
  // section starts [hidden], where every offset reads 0 - re-sync once it becomes visible
  new MutationObserver(sync).observe(section, {
    attributes: true,
    attributeFilter: ["hidden"],
  });
  sync();
  };
  document.querySelectorAll("[data-jm3-rail]").forEach(init);
})();

// tear-off reveal - one-way by design, torn state persists until reload.
// Cards without a back face (tonight's, no winner yet) stay static.
document.querySelectorAll("[data-jm3-rail] .jm-roll-card").forEach((card) => {
  if (!card.querySelector(".jm-roll-card-back")) return;
  card.addEventListener("click", () => card.classList.add("is-torn"), {
    once: true,
  });
});
